// Joins contact rows onto property rows for the Quick Assessor table. The
// contact's custom_fields is renamed contact_custom_fields so it can never
// clobber the property's own custom_fields in the spread.
export const joinContactsToProperties = (properties, resContacts) => {
  const contacts = [];
  if (resContacts) {
    resContacts.forEach((c) => {
      if (c !== null) {
        const { id, custom_fields, ...rest } = c;
        contacts.push({ ...rest, contact_custom_fields: custom_fields || {} });
      }
    });
  }

  return (properties || []).map((p) => {
    if (!p.contact_id) {
      return { ...p };
    }
    const contactValue = contacts.find(
      (c) => c.contactTransferID === p.contact_id
    );
    return { ...p, ...contactValue };
  });
};
